'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseForms', ['$scope', function ($scope) {
        $scope.resetLicense();
        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.licensing.license.form.builder',
                    params: [
                        {
                            name: 'formID',
                            field: 'id'
                        },
                        {
                            name: 'form',
                            field: ''
                        }
                    ]
                }
            }
        ]
    }])
;